import { tv } from '@/utils/libs/tailwind-variants';
/**
 * PhoneField のスタイル
 */
export const phoneFieldStyle = tv({
    slots: {
        base: [],
        inputWrap: ['flex flex-nowrap gap-16'],
        label: ['mb-8'],
    },
});
